import * as Sentry from '@sentry/browser';

(function () {
    'use strict';
    'ngInject';

    angular.module('app.ctrls').controller('SignInCtrl', signInCtrl);

    function signInCtrl($rootScope, $scope, $location, AuthService, blockUI) {
        $rootScope.showHeader = false;
        $scope.user = '';
        $scope.password = '';

        $scope.navigate = function (path) {
            $location.path(path);
        };

        $scope.signInLocal = function () {
            if ($.trim($scope.user).length > 0 && $.trim($scope.password).length > 0) {
                blockUI.start();

                AuthService.passwordLogin($scope.user, $scope.password)
                    .then(function () {
                        blockUI.stop();
                    })
                    .catch(function (error) {
                        if (error?.data?.error !== 'The email or password you entered is incorrect') {
                            window.rumReportError(error);
                        }
                        blockUI.stop();
                    });
            }
        };

        $scope.createUser = function () {
            $location.path('/signup');
        };

        $scope.forgotPassword = function () {
            $location.path('/forgotPassword');
        };
    }
})();
